export default{
    arkaplankontrol:false,
    haberkontrol:false,
    baskankontrol:false,
    Arkaplan:'',
    Haberler:[],
    Baskan:{},
    apikey1:'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',
};